var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 49,
    viewBox: "0 0 40 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63812 23.6474V13.9224L20.0009 7.96536C23.4589 9.95105 26.9094 11.9367 30.3637 13.9224V28.9828H11.7795H2.15075C1.79889 28.184 1.43947 27.3965 1.14815 26.5788C-0.047411 23.2216 -0.308466 19.612 0.361198 16.1417C1.08761 12.3588 2.92257 8.75286 5.85849 5.83273C9.76676 1.94424 14.8857 0 20.0009 0C25.1236 0 30.2426 1.94424 34.1433 5.83273C38.0478 9.72498 40 14.823 40 19.9172C40 25.0152 38.0478 30.1169 34.1433 34.0016L20.0009 48.0861L5.85849 34.0054C5.26072 33.4101 4.6932 32.7695 4.17488 32.1026H8.37068L20.0009 43.6889L31.9375 31.8012C35.2291 28.5231 36.8787 24.2164 36.8787 19.9172C36.8787 15.618 35.2291 11.315 31.9375 8.03319C28.6422 4.74757 24.3178 3.10853 20.0009 3.10853C15.684 3.10853 11.3634 4.75134 8.06801 8.02942C5.58609 10.5012 4.04246 13.5381 3.42954 16.7182C2.83933 19.7627 3.10417 22.9315 4.21271 25.8629H27.2386V15.7084C24.821 14.3181 22.4109 12.9315 20.0009 11.5449L12.767 15.7084V23.6549H9.63812V23.6474Z",
    fill: "#306199"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c6b3f6966601273fd1dd59663da82516.svg";
export { ForwardRef as ReactComponent };